


  
  

  var faEdoc = {
    prefix: 'fak',
    iconName: 'edoc',
    icon: [
      512,
      512,
      [],
      'e004',
      
      'M354.4 83.9c26.3-26.6 69-26.5 95.2 0c26.2 26.6 26.2 69.8 0 96.4L330.8 300.7c-17.4 17.6-40.6 27.3-65.2 27.3l-39.4 0c-9.7 0-17.6-8-17.6-17.8l0-39.9c0-24.9 9.6-48.4 26.9-66l90.2-91.4c.1-.2 .2-.3 .3-.5s.2-.4 .4-.6s.4-.3 .6-.4c0 0 0 0 0 0c.2-.1 .3-.2 .5-.3l26.9-27.2zM265.6 292.4c15.2 0 29.6-6 40.3-16.9l78.7-79.6-45.5-46.1-78.7 79.7c-10.7 10.9-16.7 25.4-16.7 40.8l0 22.1 21.8 0zM424.8 155.1c12.5-12.7 12.5-33.3 0-46s-32.9-12.7-45.5 0L364 124.6l45.5 46.1 15.4-15.5zM115.9 412l311.4 0c10.1 0 18.3 8.1 18.3 18s-8.2 18-18.3 18l-311.4 0c-40.4 0-73.3-32.3-73.3-72s32.9-72 73.3-72l36.6 0c10.1 0 18.3 8.1 18.3 18s-8.2 18-18.3 18l-36.6 0c-20.2 0-36.6 16.1-36.6 36s16.4 36 36.6 36z'
      
    ]
  };

  

  
  

  var faLowPriority = {
    prefix: 'fak',
    iconName: 'low-priority',
    icon: [
      634,
      512,
      [],
      'e003',
      
      'M196.2 503.5c-21.6 20.9-67.9-19.2-43.8-43.8s41-40 41-40c-54.3-2.9-100-23.8-137.1-62.9S1 272.1 1 217.8C1 161.6 20 114 59.1 74.9s86.7-59 143.8-59c0 0 48.7 0 84.2 0s35.5 62.9 0 62.9-84.2 0-84.2 0c-39 0-72.4 13.3-99 40c-27.6 26.7-41 60-41 98.1c0 37.1 12.4 68.6 37.1 95.2c23.8 26.7 55.2 41 91.4 43.8c0 0-13.9-14.4-39-39s19.3-65.8 43.8-42.9 115.2 114.3 115.2 114.3-93.6 94.3-115.2 115.2zM353.6 49.8c0-17.2 13.1-31.8 31.3-31.8H590.4c17 0 31.3 14.6 31.3 31.8c0 18.6-14.4 31.8-31.3 31.8H384.9c-18.3 0-31.3-13.3-31.3-31.8zm0 167c0-17.2 13.1-31.8 31.3-31.8H590.4c17 0 31.3 14.6 31.3 31.8c0 18.6-14.4 31.8-31.3 31.8H384.9c-18.3 0-31.3-13.3-31.3-31.8zM621.7 388.7c0 18.5-14.4 31.8-31.3 31.8H384.9c-18.3 0-31.3-13.3-31.3-31.8c0-17.2 13.1-31.8 31.3-31.8H590.4c17 0 31.3 14.6 31.3 31.8z'
      
    ]
  };

  

  
  

  var faNewEmail = {
    prefix: 'fak',
    iconName: 'new-email',
    icon: [
      512,
      512,
      [],
      'e006',
      
      'M39.3 142.3c0-6.5 5.7-13.1 13.1-13.1l314.1 0c6.5 0 13.1 6.5 13.1 13.1l0 18.8-18.8 14.7c13.9-4.9 29.4-7.4 45-7.4c2 0 3.9 .2 5.9 .4c2.2 .2 4.6 .4 7.1 .4l0-27c0-28.6-23.7-52.3-52.3-52.3l-314.1 0C22.9 89.9 0 113.7 0 142.3L0 351.7C0 381.1 22.9 404 52.3 404l242.1 0c-9.8-11.5-18-24.5-22.9-39.3l-219.2 0c-7.4 0-13.1-5.7-13.1-13.1l0-139.9 116.1 94.9c30.3 25.4 74.4 26.2 106.3 1.6c.8-23.7 7.4-46.6 18-66.3L238 276.4c-17.2 13.9-40.9 13.9-58.1 0L39.3 161.1l0-18.8zM300.4 365.4A113.3 113.3 0 1 0 496.6 252 113.3 113.3 0 1 0 300.4 365.4zm98.4-7.1c-6.2 0-10.6-4.4-10.6-10.6l0-28.4-28.4 0c-6.2 0-10.6-4.4-10.6-10.6c0-5.8 4.4-10.6 10.6-10.6l28.4 0 0-28.4c0-5.8 4.4-10.6 10.6-10.6c5.8 0 10.6 4.9 10.6 10.6l0 28.4 28.4 0c5.8 0 10.6 4.9 10.6 10.6c0 6.2-4.9 10.6-10.6 10.6l-28.4 0 0 28.4c0 6.2-4.9 10.6-10.6 10.6z'
      
    ]
  };

  

  
  

  var faReplyToMessage = {
    prefix: 'fak',
    iconName: 'reply-to-message',
    icon: [
      491,
      512,
      [],
      'e002',
      
      'M224 59.3c-2.6 6.1-3.9 12.7-3.9 19.4c0 8 1.9 15.7 5.4 22.6l-169.4-.1c-7.7 0-14 6.3-14 14V367.7c0 7.7 6.3 14 14 14h84.2c23.2 0 42.1 18.8 42.1 42.1v14l63.6-47.7c7.3-5.4 16.1-8.4 25.2-8.4H392.8c7.7 0 14-6.3 14-14l-.7-123.9c4.5 1.4 9.3 2.2 14.3 2.2c7.7 0 15.2-1.8 22.1-5.6c1.3-.7 3.3-1.8 5.7-3.4l.7 130.7c0 30.9-25.2 56.1-56.1 56.1H271.2l-88.8 66.6-.2 .2-4.5 3.3-15 11.2c-4.3 3.2-10 3.7-14.7 1.3s-7.7-7.2-7.7-12.5v-70H56.1c-31 0-56.1-25.2-56.1-56.1V115.2c0-31 25.2-56.1 56.1-56.1L224 59.3zM133.3 269.6c-11.7 0-21 9.4-21 21s9.4 21 21 21h98.2c11.7 0 21-9.4 21-21s-9.4-21-21-21H133.3zm0-84.2c-11.7 0-21 9.4-21 21s9.4 21 21 21H315.6c11.7 0 21-9.4 21-21s-9.4-21-21-21H133.3zM353.5 1.2c5.1 2.3 8.4 7.4 8.4 12.9V42.5h49.6c43 0 77.9 34.9 77.9 77.9c0 50.2-36.1 72.6-44.4 77.1c-1.1 .6-2.3 .8-3.6 .8c-4.8 0-8.7-3.9-8.7-8.7c0-3.3 1.9-6.4 4.3-8.6c4.2-3.9 9.8-11.7 9.8-25.1c0-23.5-19-42.5-42.5-42.5H361.9v28.3c0 5.6-3.3 10.7-8.4 12.9s-11.1 1.3-15.2-2.4L267.4 88.5c-3-2.7-4.7-6.6-4.7-10.6s1.7-7.8 4.7-10.5L338.2 3.6c4.2-3.8 10.1-4.7 15.2-2.4z'
      
    ]
  };

  

  
  

  var faRequest = {
    prefix: 'fak',
    iconName: 'request',
    icon: [
      492,
      512,
      [],
      'e000',
      
      'M115.4 56.3l261.1 0c3.8 0 7.7 3.8 7.7 7.7l0 163.2 40.3-34.6 5.8-2.9 0-125.8c0-28.8-25-53.8-53.8-53.8l-261.1 0c-29.8 0-53.8 25-53.8 53.8l0 125.8c.4 .4 1 .8 1.6 1.3c.9 .7 2.1 1.5 3.2 2.6l41.3 33.6 0-163.2c0-3.8 2.9-7.7 7.7-7.7zM46.3 448l0-171.8L182.6 387.5c36.5 30.7 89.3 30.7 126.7 0L445.7 276.2l0 171.8c0 4.8-3.8 7.7-7.7 7.7l-384 0c-4.8 0-7.7-2.9-7.7-7.7zM28.1 209.9c-15.4 0-27.8 13.4-27.8 28.8L.2 448c0 29.8 24 53.8 53.8 53.8l384 0c29.8 0 53.8-24 53.8-53.8l0-209.3c0-15.4-13.4-28.8-28.8-28.8c-6.7 0-13.4 2.9-18.2 6.7L279.6 352c-20.2 16.3-48 16.3-68.2 0L46.3 216.6c-4.8-3.8-11.5-6.7-18.2-6.7zM203.4 103.7c3.7-4.1 3.4-10.4-.8-14.1c0 0 0 0 0 0c-4.1-3.7-10.4-3.4-14.2 .8l-23 25.5-9.2-9.2c-3.9-3.9-10.3-3.9-14.1 0s-3.9 10.3 0 14.2l16.7 16.7c2 1.9 4.6 3 7.3 2.9s5.3-1.2 7.2-3.3l30.1-33.4zm0 66.8c3.7-4.1 3.4-10.4-.8-14.2c0 0 0 0 0 0c-4.1-3.7-10.4-3.4-14.2 .7l-23 25.5-9.2-9.2c-3.9-3.9-10.2-3.9-14.1 0s-3.9 10.2 0 14.2l16.7 16.7c2 1.9 4.6 3 7.3 2.9s5.3-1.3 7.2-3.3l30.1-33.4zM246 100.3c-7.4 0-13.4 6-13.4 13.4s6 13.4 13.4 13.4l93.5 0c7.4 0 13.4-6 13.4-13.4s-6-13.4-13.4-13.4l-93.5 0zm0 66.8c-7.4 0-13.4 6-13.4 13.4s6 13.4 13.4 13.4l93.5 0c7.4 0 13.4-6 13.4-13.4s-6-13.4-13.4-13.4l-93.5 0zm-26.7 66.8c-7.4 0-13.4 6-13.4 13.4s6 13.4 13.4 13.4l120.2 0c7.4 0 13.4-6 13.4-13.4s-6-13.4-13.4-13.4l-120.2 0zm-42.8 3.3a20 20 0 1 0 -34.7 20 20 20 0 1 0 34.7-20z'
      
    ]
  };

  



export {

  faEdoc,
  

  faLowPriority,
  

  faNewEmail,
  

  faReplyToMessage,
  

  faRequest,
  

};
